import AlertModal from "modals/AlertModal";
import MsgModal from "modals/MsgModal";
import Post from "modals/Post";
import EditPasswordModal from "modals/EditPasswordModal";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { requestGet, requestPost } from "utils/AxiosApi";

import "style/style.css";
import { phoneHyphen, emailValidate } from "utils/CommonUtils";

import Loader from "utils/Loader";
import WithdrawalModal from "modals/WithdrawalModal";
import RightMenu from "layout//RightMenu";

const medmall_logo = "/img/medmall_org_logo.jpg";

const Mypage = () => {
  let history = useNavigate();

  const [showMenu, setShowMenu] = useState(false);
  //주소 모달창 open
  const [addModalOpen, setAddModalOpen] = useState(false);

  //모달 alert
  const [AlertModalOpen, setAlertModalOpen] = useState(false);
  const [AlertModalMsg, setAlertModalMsg] = useState("");

  //모달창 open
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");

  //비밀번호 변경 모달
  const [editPasswordModalOpen, setEditPasswordModalOpen] = useState(false);

  //회원탈퇴 모달
  const [withdrawalModalOpen, setWithdrawalModalOpen] = useState(false);

  //loader
  const [isLoading, setIsLoading] = useState(false);

  const [regInputs, setRegInputs] = useState({
    email: "",
    name: "",
    gender: "M",
    phone: "",
    orgNm: "",
    orgNum: "",
    addr: "",
    addDetail: "",
  });

  const [emptyinputs, setEmptyinputs] = useState("");

  const setRegInputsData = (name: any, value: any) => {
    setRegInputs({
      ...regInputs,
      [name]: value,
    });
  };

  const inputChange = (e: any) => {
    const { value, name } = e.target;
    setRegInputsData(name, value);
  };

  const radioLabelBtnClick = (value: any) => {
    setRegInputsData("gender", value);
  };

  const phoneValidate = (e: any) => {
    const { value, name } = e.target;
    let phoenNumber = phoneHyphen(value);
    setRegInputsData(name, phoenNumber);
  };

  const { email, name, gender, phone, orgNm, orgNum, addr, addDetail } =
    regInputs;

  const moveScreen = () => {
    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
  };

  const isEmpty = (value: any) => {
    if (value.length > 0) {
      return false;
    }
    return true;
  };

  const [idValidMsg, setIdValidMsg] = useState("");

  const checkEmptyInput = () => {
    var submitInput = false;

    var emailVali = emailValidate(regInputs.email);

    if (!emailVali.valid) {
      setIdValidMsg(emailVali.id);
      setEmptyinputs("email");
      moveScreen();
      setModalOpen(true);
      setModalMsg(emailVali.id);
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    if (isEmpty(regInputs.phone)) {
      setModalOpen(true);
      setModalMsg("연락처를 입력해주세요.");
      setEmptyinputs("phone");
      moveScreen();
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    if (isEmpty(regInputs.orgNm)) {
      setModalOpen(true);
      setModalMsg("의료기관명을 입력해주세요.");
      setEmptyinputs("orgNm");
      moveScreen();
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    if (isEmpty(regInputs.orgNum)) {
      setModalOpen(true);
      setModalMsg("요양기관번호를 입력해주세요.");
      setEmptyinputs("orgNum");
      moveScreen();
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    if (isEmpty(regInputs.addr)) {
      setModalOpen(true);
      setModalMsg("주소를 입력해주세요.");
      setEmptyinputs("addr");
      moveScreen();
      return submitInput;
    } else {
      setEmptyinputs("");
    }

    return true;
  };

  const memberSignUp = async () => {
    setSubmitBtn(false);
    setIsLoading(true);
    let data = await requestPost("/api/member/edit", {
      regInputs,
    });
    if (data.result === true) {
      setModalOpen(true);
      setModalMsg("수정되었습니다.");
      setSubmitBtn(false);
      setIsLoading(false);
    }
  };

  const [submitBtn, setSubmitBtn] = useState(false);

  const onSubmit = () => {
    var submit = checkEmptyInput();
    if (submit) {
      if (!submitBtn) {
        setAlertModalOpen(true);
        setAlertModalMsg("회원정보를 수정하시겠습니까?");
      }
    }
  };

  const alertConfirm = () => {
    memberSignUp();
  };

  const getInitData = async () => {
    var d: any = await requestGet("/api/member/info", {});
    let data = d.info;
    let inputData = regInputs;

    inputData.email = data.id;
    inputData.name = data.name;
    inputData.gender = data.gender;
    inputData.phone = data.phone;
    inputData.orgNm = data.orgNm;
    inputData.orgNum = data.orgNum;
    inputData.addr = data.addr;
    inputData.addDetail = data.addrDetail;

    setRegInputs({ ...inputData });
  };

  useEffect(() => {
    getInitData();
  }, []);

  const modalConfirm = () => {
    setModalOpen(false);
  };

  const setEditPassword = () => {
    setEditPasswordModalOpen(false);
  };

  return (
    <div>
      <div className="header-logo-img" onClick={() => history("/main")}>
        <img src={medmall_logo} alt="logo" className="header-logo-img"></img>
      </div>
      <div className="top-menu">
        <span onClick={() => history("/mypage")} id="font-SCD4">
          마이페이지
        </span>
        <span onClick={() => history("/login")} id="font-SCD4">
          로그아웃
        </span>
      </div>
      <div className="top-mobile-menu">
        <img
          className="btn-top-menu"
          src={"/svg/menu.svg"}
          alt="menuSvg"
          onClick={() => setShowMenu(true)}
        />
      </div>
      <hr
        style={{
          width: "97vw",
          border: "solid 1px #eaeaea",
          marginTop: "20px",
        }}
      ></hr>
      <div className="display-center-margin-50">
        <div>
          <div className="span-left-text" id="font-SCD4">
            <div
              style={{
                marginBottom: "40px",
                textAlign: "left",
                width: "90vw",
                maxWidth: "500px",
              }}
            >
              <div className="span-blue-20">
                <span id="font-SCD7">회원 정보</span>
              </div>
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">아이디(이메일)</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="email"
                value={email}
                disabled={true}
              ></input>
              {emptyinputs === "email" && (
                <span className="warning-text">{idValidMsg}</span>
              )}
            </div>

            <div>
              <button
                className="btn-blue-transparent-w120"
                id="font-SCD4"
                onClick={() => setEditPasswordModalOpen(true)}
              >
                비밀번호 변경
              </button>
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">이름</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40" /*의료기관 : medical institution*/
                type="text"
                name="name"
                value={name}
              ></input>
              {emptyinputs === "name" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">이름을 입력해주세요</span>
                </div>
              )}
            </div>

            <div className="input-form" style={{ marginTop: "10px" }}>
              <div className="span-gray-text" style={{ float: "left" }}>
                <span className="input-label">성별</span>
              </div>
              <div className="radio-box" style={{ marginLeft: "70px" }}>
                <div className="radio-box-l">
                  <input
                    onChange={inputChange}
                    type="radio"
                    name="gender"
                    value="M"
                    checked={gender === "M"}
                  ></input>
                  <label onClick={() => radioLabelBtnClick("M")}>남성</label>
                </div>
                <div className="radio-box-r">
                  <input
                    onChange={inputChange}
                    type="radio"
                    name="gender"
                    value="F"
                    checked={gender === "F"}
                  ></input>
                  <label onClick={() => radioLabelBtnClick("F")}>여성</label>
                </div>
              </div>
            </div>
            <div style={{ clear: "both", marginBottom: "20px" }}></div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">연락처(휴대폰번호)</span>
              </div>
              <input
                onChange={phoneValidate}
                className="input-form-w97p-40"
                type="text"
                name="phone"
                value={phone}
                maxLength={13}
              ></input>
              {emptyinputs === "phone" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">연락처를 입력해주세요.</span>
                </div>
              )}
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">의료기관명</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="orgNm"
                value={orgNm}
              ></input>
              {emptyinputs === "orgNm" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">
                    의료기관명을 입력해주세요.
                  </span>
                </div>
              )}
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">요양기관번호</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="orgNum"
                value={orgNum}
              ></input>
              {emptyinputs === "orgNum" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">
                    요양기관번호을 입력해주세요.
                  </span>
                </div>
              )}
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">주소(의료기관 기준)</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="addr"
                value={addr}
                onClick={() => setAddModalOpen(true)}
              ></input>
              {emptyinputs === "addr" && (
                <div style={{ marginTop: "-10px", marginBottom: "15px" }}>
                  <span className="warning-text">주소를 입력해주세요.</span>
                </div>
              )}
            </div>

            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">상세주소</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="addDetail"
                value={addDetail}
              ></input>
            </div>
          </div>

          <div className="img-form">
            <button
              className="btn-submit"
              onClick={onSubmit}
              disabled={submitBtn}
              id="font-SCD7"
            >
              수정
            </button>
            <button
              className="btn-border-red-w130"
              onClick={() => setWithdrawalModalOpen(true)}
              disabled={submitBtn}
              id="font-SCD7"
              style={{ marginLeft: "15px" }}
            >
              회원탈퇴
            </button>
          </div>
        </div>

        <div style={{ marginBottom: "50px" }}></div>
      </div>

      {addModalOpen && (
        <Post
          setAddModalOpen={setAddModalOpen}
          setRegInputs={setRegInputs}
          regInputs={regInputs}
        ></Post>
      )}

      {AlertModalOpen && (
        <AlertModal
          setOpenModal={setAlertModalOpen}
          modalMsg={AlertModalMsg}
          clickConfirm={alertConfirm}
        ></AlertModal>
      )}
      {modalOpen && (
        <MsgModal
          setOpenModal={setModalOpen}
          modalMsg={modalMsg}
          modalConfirm={modalConfirm}
        ></MsgModal>
      )}
      {editPasswordModalOpen && (
        <EditPasswordModal
          setOpenModal={setEditPasswordModalOpen}
          modalConfirm={setEditPassword}
        ></EditPasswordModal>
      )}
      {withdrawalModalOpen && (
        <WithdrawalModal
          setOpenModal={setWithdrawalModalOpen}
        ></WithdrawalModal>
      )}
      {isLoading && <Loader isLoading={isLoading}></Loader>}
      <RightMenu show={showMenu} setShowMenu={setShowMenu}></RightMenu>
    </div>
  );
};

export default Mypage;
